import ModelEvaluationPost from './blogs/model_evaluation'
import AIEmployeesPost from './blogs/ai_employees_post'
import ClusteringFinancePost from './blogs/clustering_finance_post'
import SyntheticBankingDataPost from './blogs/synthetic_bank_post'

const getAllBlogPosts = () => [
  ModelEvaluationPost(),
  AIEmployeesPost(),
  ClusteringFinancePost(),
  SyntheticBankingDataPost()
  // Add other blog posts here when you create them
  // AIProductScalingPost(),
  // BioInspiredAIPost()
];

export default getAllBlogPosts;